// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3zeA4","bigColWidth":"Table_bigColWidth__1ItNT","biggerColWidth":"Table_biggerColWidth__3aRH4","row":"Table_row__2G65g","col":"Table_col__1WGFU"};